// src/pages/Wellnessjournals/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getWellnessJournals, PRODUCTS_PER_PAGE } from "../data/wellnessJournals";

export default function Wellnessjournals() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getWellnessJournals()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/wellness-journals",
    announcement: {
      headline: "Start your wellness journey — beautifully.",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Wellness Journals",
      subtitle: "A daily practice, beautifully bound",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "This journal genuinely changed my mornings. I feel calmer and more grounded every single day.",
      quoteLink: "#",
      rating: "4.7",
      ratingCount: "1000+",
    },
  };

  return <CollectionPage config={config} />;
}